import { initialState } from "./state";

export const setPeople = (state, payload) => {
  state.people = payload;
};

export const reset = (state) => {
  const s = initialState();

  Object.keys(s).forEach((key) => {
    state[key] = s[key];
  });
};
